module.exports = "/images/vendor/flag-icon-css/flags/1x1/bn.svg?0adbb6646a1e26c449969a38e3bbc3ba";